import { render } from "./TermsAndConditionsModal.vue?vue&type=template&id=069ba6ee&scoped=true&ts=true"
import script from "./TermsAndConditionsModal.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditionsModal.vue?vue&type=script&lang=ts"

import "./TermsAndConditionsModal.vue?vue&type=style&index=0&id=069ba6ee&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bakery-platform/bakery-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-069ba6ee"]])

export default __exports__